import { render, staticRenderFns } from "./Semanal.vue?vue&type=template&id=be3cc94a&scoped=true"
import script from "./Semanal.vue?vue&type=script&lang=js"
export * from "./Semanal.vue?vue&type=script&lang=js"
import style0 from "./Semanal.vue?vue&type=style&index=0&id=be3cc94a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3cc94a",
  null
  
)

export default component.exports